import { Banner, CommonAllObjectsQuery, FilterOps, QueryVariablesTypes } from '@@types'
import { useQuery, WatchQueryFetchPolicy } from '@apollo/client'
import { useMemo } from 'react'

import { IMAGE_SIZES, ImageSize } from '@shared/contants'

import { GQL_QUERY_ALL_BANNERS } from '../model/queries'


type useAllBannersParams = {
  bannerType?: string | null;
  typeId?: string | null;
  limit?: number;
  page?: number;
  style?: ImageSize;
  mobileSlideStyle?: ImageSize;
  fetchPolicy?: WatchQueryFetchPolicy
}

type AllBannersVariablesTypes = QueryVariablesTypes & {
  style?: string
  bannerMobileSlideStyle2?: string
}

export function useFetchAllBanners ({
  bannerType = null,
  typeId = null,
  limit = 12,
  page = 1,
  style = IMAGE_SIZES.FULLHD,
  mobileSlideStyle = IMAGE_SIZES.HERO,
  fetchPolicy = 'cache-and-network',
}: useAllBannersParams = {
}) {
  const { data, loading, error } = useQuery<CommonAllObjectsQuery<'allBanners', Banner>, AllBannersVariablesTypes>(
    GQL_QUERY_ALL_BANNERS,
    {
      variables: {
        pager: { limit, page },
        style,
        bannerMobileSlideStyle2: mobileSlideStyle,
        filter: {
          or: [
            {
              fields: [ 'code' ],
              op: FilterOps.EQUAL,
              value: bannerType
            },
            {
              fields: [ 'banner_type_id' ],
              op: FilterOps.EQUAL,
              value: typeId
            }
          ]
        },
      },
      fetchPolicy
    }
  )

  const banners = useMemo(() => data?.allBanners?.edges?.filter(Boolean) || [], [ data ])

  return { 
    data, 
    banners,
    loading, 
    error
  }
}